import { render, staticRenderFns } from "./ViewRegularizacion.vue?vue&type=template&id=6447ea04"
import script from "./ViewRegularizacion.vue?vue&type=script&lang=js"
export * from "./ViewRegularizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports